exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".label-placeholder{display:inline-block}.form-container .btn{width:100%}", "", {"version":3,"sources":["/var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/property-search/property-search.component.css"],"names":[],"mappings":"AAAA,mBACI,oBAAsB,CACzB,qBAGG,UAAY,CACf","file":"property-search.component.css","sourcesContent":[".label-placeholder {\n    display: inline-block;\n}\n\n.form-container .btn {\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/property-search/property-search.component.css
// module id = MKb2
// module chunks = 0